import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=c3801e3c&"
import script from "./Toasts.vue?vue&type=script&lang=js&"
export * from "./Toasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports